import {Component,Inject,OnInit} from '@angular/core';
import {Communaute} from "@domain/travel/communaute";
import {MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,MatLegacyDialogRef as MatDialogRef} from "@angular/material/legacy-dialog";
import {filter,finalize,first} from "rxjs/operators";
import {AdminTravelhubService} from "@components/admin/voyages/travelhub/admin-travelhub.service";
import {ParamConnexion} from "@domain/travel/param-connexion";
import {ConfirmService} from "@share/component/confirmation/confirm.service";
import {TranslateService} from "@ngx-translate/core";
import {TravelHubSBTConfigUsed} from "@domain/travel/travel-hub-sbt-config-used";
import {RefSbt} from "@domain/travel/ref-sbt";
import {TravelHubSbtConfigUsedParamConnexion} from "@domain/travel/travel-hub-sbt-config-used-param-connexion";
import {ReferentielCommunauteComponent} from "@components/admin/voyages/travelhub/sbt-config/sbt-config-add/referentiels/communaute/referentiel-communaute.component";

/**
 * Popup de détails d'un référentiel de type communauté
 *
 * @author Laurent Convert
 * @date 22/11/2023
 */
@Component({
    host: {'data-test-id': 'referentiel-communaute-add'},
    templateUrl: './referentiel-communaute-add.component.html',
    styleUrls: ['./referentiel-communaute-add.component.scss']
})
export class ReferentielCommunauteAddComponent implements OnInit {
    /** RegExp pour la validation de la valeur suivant le nombre de caractères attendus */
    regExpValidatorValeur : RegExp;

    /** La communauté en cours de visualisation */
    communaute: Communaute;

    /** Paramètre de connexion */
    sbtConfigUsedParam: TravelHubSbtConfigUsedParamConnexion;

    /** Paramètre de connexion */
    paramConnexion: ParamConnexion;

    /** Indicateur de chargement en cours */
    isLoading: boolean = true;

    /** Indicateur de suppression en cours */
    isDeleting: boolean = false;

    /** Indicateur d'enregistrement en cours */
    isSaving: boolean = false;

    /** Indicateur de traitement en cours (enregistrement ou suppression) */
    get isProcessing(): boolean {
        return this.isSaving || this.isDeleting;
    }

    /**
     * Constructeur
     *
     * @param data Données transmises à l'ouverture de la popup
     * @param matDialogRef Référence de la popup
     * @param adminTravelhubService Service de gestion du module d'administration du TravelHub
     * @param confirmService Service de confirmation utilisateur via modale
     * @param translateService Service de traduction
     */
    constructor(@Inject(MAT_DIALOG_DATA) public data: {
                    referentiel: Communaute,
                    sbt: RefSbt,
                    sbtConfigUsed: TravelHubSBTConfigUsed,
                    listeSBTConfigUsed: Array<TravelHubSbtConfigUsedParamConnexion>,
                    parent: ReferentielCommunauteComponent
        },
        private matDialogRef: MatDialogRef<ReferentielCommunauteAddComponent>,
        private adminTravelhubService: AdminTravelhubService,
        private confirmService: ConfirmService,
        private translateService: TranslateService
    ) {
    }

    /**
     * Initialisation du composant
     */
    ngOnInit() {
        //Chargement de la communauté
        this.adminTravelhubService.loadCommunaute(this.data.referentiel,this.data.listeSBTConfigUsed)
            .pipe(finalize(() => this.isLoading = false))
            .subscribe(result => {
                //Récupération des données depuis le résultat
                this.paramConnexion = result.data.paramConnexion;

                //Création ?
                if (this.data.referentiel.idCommunaute > 0) {
                    //Modification
                    this.communaute = new Communaute(result.data.communaute);
                } else {
                    //Création
                    this.communaute = new Communaute(this.data.referentiel);
                }

                //Recherche du paramètre
                this.sbtConfigUsedParam = this.adminTravelhubService.findConfigUsed(this.data.listeSBTConfigUsed,this.data.sbtConfigUsed);

                //Vérification des contraintes de validité du paramètre
                if (this.sbtConfigUsedParam.minParam > 0 || this.sbtConfigUsedParam.maxParam > 0) {
                    //Construction de la regexp
                    this.regExpValidatorValeur = new RegExp(`^.{${this.sbtConfigUsedParam.minParam},${this.sbtConfigUsedParam.maxParam > 0 ? this.sbtConfigUsedParam.maxParam : ''}}$`,'g');
                }
            });
    }

    /**
     * Suppression de la communauté en cours d'affichage
     */
    deleteCommunaute(): void {
        //Affichage de la confirmation de suppression
        this.confirmService.showConfirm(this.translateService.instant('global.suppression.confirmation'))
            .pipe(filter(isConfirmed => isConfirmed))
            .subscribe({
                next: () => {
                    //Suppression en cours
                    this.isDeleting = true;

                    //Suppression
                    this.data.parent.deleteReferentiel(this.communaute).pipe(first()).subscribe(isSuccess => {
                        //Vérification du succès de la suppression
                        if (isSuccess) {
                            //Fermeture de la popup
                            this.matDialogRef.close(true);
                        } else {
                            //Erreur lors de suppression, fin du traitement
                            this.isDeleting = false;
                        }
                    });
                }
            });
    }

    /**
     * Suppression de la communauté en cours d'affichage
     */
    saveCommunaute(): void {
        //Enregistrement en cours
        this.isSaving = true;

        //Enregistrement
        this.data.parent.saveReferentiel(this.communaute).pipe(first()).subscribe(isSuccess => {
            //Vérification du succès de l'enregistrement
            if (isSuccess) {
                //Fermeture de la popup
                this.matDialogRef.close(true);
            } else {
                //Erreur lors d'enregistrement, fin du traitement
                this.isSaving = false;
            }
        });
    }
}